import './index.css';
import ReactSignatureCanvas from "react-signature-canvas";
import api from "../../../config";
import { toast } from "react-toastify";
import ReactModal from "react-modal";

export default function ModalDeliverSignature({screenName, showModalDeliverSignature, setShowModalDeliverSignature, users, setReceiverID, base64, signature, setSignature, status, receiverID, id, option, getOne, method, API}){
  function postWithdraw(){
    let data = {};

    if(!receiverID){
      return toast.error("O campo recebedor é obrigatório.");
    }
    
    if(screenName === "Solicitação"){
      data = {
        assinatura: signature.getTrimmedCanvas().toDataURL('image/png'),
        recebedor: parseInt(receiverID)
      }
    } else{
      data = {
        assinatura: {
          nome: 'Assinatura',
          base64: signature.getTrimmedCanvas().toDataURL('image/png')
        },
        recebedor: parseInt(receiverID)
      }
    }

    if(signature.isEmpty()){
      return toast.error("A assinatura é obrigatória.");
    }

    return api
          [method](API, data)
          .then((response) => {
            getOne(id, option);
            setShowModalDeliverSignature(false);
              
            toast.success('Assinatura realizada com sucesso!');
          })
          .catch((error) => {
            if(error?.response?.data?.errors?.recebedor[0]){
              return toast.error(error?.response?.data?.errors?.recebedor[0]);
            }

            return toast.error(error?.response?.data?.message);
          });
  }

  return (
    <ReactModal
      isOpen={showModalDeliverSignature}
      onRequestClose={() => setShowModalDeliverSignature(false)}
      contentLabel="Informações de Usuário"
      ariaHideApp={false}
      className="modal-signature"
    >
      <form>
        <div className="modal-signature__header formDiv" style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
          <h2 className="modal___title">Recebedor:</h2>
          <select className="modal___select" onChange={(e) => setReceiverID(e.target.value)} disabled={['009'].indexOf(status) > -1}>
            <option value="">Selecione</option>
            {users.map((user, index) => {
              if(user.nome_fantasia){
                return (
                    <option className="modal____option" value={user.id} selected={id && user.id === receiverID} key={index}>{user.nome_fantasia}</option>
                  )
                }
            })}
          </select>
        </div>
        <div className="modal__signature">
          {['007', '009'].indexOf(status) > -1 ? 
            <img className="modal___image" src={`data:image/png;base64,${base64}`} />
              :
            <ReactSignatureCanvas penColor='black' ref={data => setSignature(data)} canvasProps={{className: 'modal___canva'}} />
          }
        </div>
        <div className="modal__buttons">
          <button type='button' onClick={() => postWithdraw()} className="buttonTab modal___buttom">Confirmar Assinatura</button>
          <button type='button' onClick={() => signature.clear()} className="buttonCancel modal___buttom">Limpar</button>
          <button type='button' onClick={() => setShowModalDeliverSignature(false)} className="buttonCancel modal___buttom">Fechar</button>
        </div>
      </form>
    </ReactModal>
  )
}